<template>
  <div class="login-container">
    <!-- 左側表單區域 -->
    <div class="form-section">
      <span class="page-title">忘記密碼</span>
      <p>
        請輸入您註冊的電子信箱，系統將會發送重置密碼的連結至您的信箱。
      </p>
      <a-form @finish="onFinish">
        <a-form-item name="username" rules="[ { required: true, message: '電子信箱!' } ]">
          <a-label class="label">電子信箱</a-label>
          <a-input placeholder="請輸入您的電子信箱" class="input"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" block class="btn-submit">確認</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 右側背景區域 -->
    <div class="background-section">
      <div class="background-overlay">
        <!--        <img src="@/assets/background_login.webp" alt="彰化鍊水監測系統" class="logo"/>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  methods: {
    onFinish(values) {
      console.log('Form values:', values);
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
}

.form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 100px;
  max-width: 500px;
  z-index: 10;
  background-color: #fff;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.page-title {
  font-size: 48px;
  margin-bottom: 20px;
  text-align: center;
}

.label {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  margin-top: 12px;
}

.input {
  margin-top: 16px;
  padding: 12px;
  font-size: 18px;
  border-radius: 8px;
}

.btn-submit {
  margin-top: 64px;
  height: auto;
  padding: 15px;
  border-radius: 16px;
  box-shadow: gray 0 3px 6px;
  font-size: 20px;
  font-weight: bold;
  background-color: #324ba6;
}

.background-section {
  flex: 2;
  background: url('~@/assets/background_forget_password.webp') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -20px;
  width: 100%;
  height: 100vh;
}

.background-overlay {
  text-align: center;
  color: white;
}
</style>
